import { render, staticRenderFns } from "./SponsorsDetails-new.vue?vue&type=template&id=3a0e1327&scoped=true&"
import script from "./SponsorsDetails-new.vue?vue&type=script&lang=js&"
export * from "./SponsorsDetails-new.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsDetails-new.vue?vue&type=style&index=0&id=3a0e1327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0e1327",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
